import { FormGroup, FormControl, Validators, FormsModule } from "@angular/forms";
import { stripGeneratedFileSuffix } from '@angular/compiler/src/aot/util';
import { EmailValidator } from 'src/app/template/customValidators/emailValidator';


export var GipUserEditForm = new FormGroup({
  USERGUID: new FormControl(),
  APPLICATION: new FormControl(),
  LOGIN: new FormControl(),
  SALUTION: new FormControl('', Validators.required),
  TITLE: new FormControl(),
  NAME: new FormControl('', [Validators.required, Validators.maxLength(100)]),
  SURNAME: new FormControl('', [Validators.required, Validators.maxLength(100)]),
  EMAIL: new FormControl('', [Validators.required, EmailValidator, Validators.maxLength(250)]),
  PHONE: new FormControl('', Validators.maxLength(20)),
  ACCEPTED: new FormControl(),

  COMPANY_MID: new FormControl('', Validators.maxLength(38)),
  COMPANY_NAME: new FormControl('', Validators.maxLength(100)),
  CONTRACT: new FormControl('', Validators.maxLength(10)),
  CONTRACT_NAME: new FormControl('', Validators.maxLength(50)),
  ROLES: new FormControl('', Validators.required),
  VERIFIED: new FormControl(),
  LOCKED: new FormControl(),
});

export class GipUserPostModel {
  USERGUID: string;
  APPLICATION: string;
  LOGIN: string;
  SALUTION: string;
  TITLE: string;
  NAME: string;
  SURNAME: string;
  FULLNAME: string;
  EMAIL: string;
  PHONE: string;
  ACCEPTED: number;
  COMPANY_MID: number;
  CONTRACT: number;
  VERIFIED: string;
  LOCKED: string;
  ROLE = new Array();


  fromFormGroupPostModel(formModel: FormGroup) {
    this.USERGUID = formModel.controls["USERGUID"].value;
    this.APPLICATION = formModel.controls["APPLICATION"].value;
    this.LOGIN = formModel.controls["LOGIN"].value;
    this.SALUTION = formModel.controls["SALUTION"].value;
    this.TITLE = formModel.controls["TITLE"].value;
    this.NAME = formModel.controls["NAME"].value;
    this.SURNAME = formModel.controls["SURNAME"].value;
    this.FULLNAME = `${this.NAME} ${this.SURNAME}`;
    this.EMAIL = formModel.controls["EMAIL"].value;
    this.PHONE = formModel.controls["PHONE"].value;
    this.ACCEPTED = formModel.controls["ACCEPTED"].value;
    this.COMPANY_MID = formModel.controls["COMPANY_MID"].value;
    this.CONTRACT = formModel.controls["CONTRACT"].value;
    this.VERIFIED = formModel.controls["VERIFIED"].value;
    this.LOCKED = formModel.controls["LOCKED"].value;
  }
}

export class GipUserUpdateModel {
  USERGUID: string;
  APPLICATION: string;
  LOGIN: string;
  SALUTION: string;
  TITLE: string;
  NAME: string;
  SURNAME: string;
  EMAIL: string;
  PHONE: string;
  ACCEPTED: number;
  COMPANY_MID: number;
  CONTRACT: number;
  VERIFIED: string;
  LOCKED: string;

  fromFormGroupUpdateUserModel(formModel: FormGroup) {
    this.USERGUID = formModel.controls["USERGUID"].value;
    this.APPLICATION = formModel.controls["APPLICATION"].value;
    this.LOGIN = formModel.controls["LOGIN"].value;
    this.SALUTION = formModel.controls["SALUTION"].value;
    this.TITLE = formModel.controls["TITLE"].value;
    this.NAME = formModel.controls["NAME"].value;
    this.SURNAME = formModel.controls["SURNAME"].value;
    this.EMAIL = formModel.controls["EMAIL"].value;
    this.PHONE = formModel.controls["PHONE"].value;
    this.ACCEPTED = formModel.controls["ACCEPTED"].value;
    this.COMPANY_MID = formModel.controls["COMPANY_MID"].value;
    this.CONTRACT = formModel.controls["CONTRACT"].value;
    this.VERIFIED = formModel.controls["VERIFIED"].value;
    this.LOCKED = formModel.controls["LOCKED"].value;
  }

  getUpdateUser() {
    return new Map ([
      ["USERGUID", `'${this.USERGUID}'`],
    ]);
  }
}

export class GipUserUpdateRoleModel {
  APPLICATION: string;
  LOGIN: string;
  ROLE: string;

  fromFormGroupUpdateRoleModel(formModel: FormGroup){
    this.APPLICATION = formModel.controls["APPLICATION"].value;
    this.LOGIN = formModel.controls["LOGIN"].value;
    this.ROLE = formModel.controls["ROLES"].value;
  }

  getUpdateRole() {
    return new Map ([
      ["APPLICATION", `'${this.APPLICATION}'`],
      ["LOGIN", `'${this.LOGIN}'`],
      ["ROLE", `'${this.ROLE}'`],
    ]);
  }
}